import React, { useState, useEffect } from 'react'
import { NavLink, Link } from 'react-router-dom'
import ViewproIcon from "../assets/logo-icon.svg"
import * as Icon from 'react-feather';
import AccountDropdown from '../components/AccountDropdown';
import Checkbox from '../components/Checkbox';
import SentQueryBox from '../components/SentQueryBox';
import Alert from '../components/Alert'
import CreatePassswordModal from '../components/Modals/CreatePassswordModal';
import SuccessModal from '../components/Modals/SuccessModal';
import MembersModal from '../components/Modals/MembersModal';
import InviteModal from '../components/Modals/InviteModal'
import { useHistory } from "react-router-dom";
// import authenticator from "../services/authenticateService";
import commonService from '../services/commonService'
import cookie from "../libs/cookie/client";
import { useGet, usePost } from "../libs/service/api";
import { Transition } from "@headlessui/react";
import ProgressBar from '../components/ProgressBar'
// import Logo from "../assets/logo.svg"
// import BG from '../assets/svg/myaccount-bg.svg'
// import CopyrightFooter from '../components/CopyrightFooter'
// import ReactTimeout from 'react-timeout';

const DashboardLayout = props => {
    const { toast, snackbar } = require('tailwind-toast')
    const userData = commonService.getUserData();
    const [memberModalVisible, setMemberModalVisible] = useState(false)
    const [passwordModalVisible, setPasswordModalVisible] = useState(false)
    const [inviteModalVisible, setInviteModalVisible] = useState(false)
    const [queryFormSubmmited, setQueryFormSubmmited] = useState(false)
    // const [message, setMessage] = useState("")
    const [isSending, setIsSending] = useState(false);
    const [isSucess, setIsSucess] = useState(false);
    // const [isLogin, setIsLogin] = useState(false)


    const queryList = [{
        label: "Set up a <strong>call</strong>",
        value: "Set up a call",
        name: "howtohelp",
        checked: false
    }, {
        label: "Schedule a <strong>demo</strong>",
        value: "Schedule a demo",
        name: "howtohelp",
        checked: false
    }, {
        label: "Explore <strong>cost</strong> proposal",
        value: "Explore cost proposal",
        name: "howtohelp",
        checked: false
    }, {
        label: "Send me some <strong>case Studies</strong>",
        value: "Send me some case Studies",
        name: "howtohelp",
        checked: false
    }, {
        label: "Understand <strong>implementation</strong>",
        value: "Understand implementation",
        name: "howtohelp",
        checked: false
    }]

    const [queryListJson, setQueryListJson] = useState(queryList)
    const history = useHistory();

    let tempqueryarraylist;
    if (localStorage.getItem("tempqueryarray") === null) {
        tempqueryarraylist = [];
    } else {
        tempqueryarraylist = JSON.parse(localStorage.getItem("tempqueryarray"))
    }

    const [tempqueryarray, setTempqueryarray] = useState(tempqueryarraylist)

    const ShareWithTeam = () => {
        if (cookie.getItem("userid") == 0) {
            history.push('/login/')
        } else if (cookie.getItem("userid") > 0 && cookie.getItem("passwordexist") == 0) {
            setPasswordModalVisible(true)
        } else if (cookie.getItem("userid") > 0 && cookie.getItem("passwordexist") == 1) {
            setMemberModalVisible(true)
        }
    }

    const onCheckBoxClick = (item, index, array) => {
        if (item.checked == undefined) {
            item.checked = true;
        } else {
            item.checked = !item.checked
        }
        setQueryListJson([...array])
        console.log(queryListJson)
    }

    const SubmitQuery = () => {
        var strMessage = ""
        for (var i = 0; i < queryListJson.length; i++) {
            if (queryListJson[i].checked == true) {
                strMessage = strMessage + queryListJson[i].value + ","
            }
        }
        if (strMessage.length == 0) {
            toast().danger('', 'Select Query').with({
                shape: 'square',
                duration: 2000,
                speed: 200,
                positionX: 'end',
                positionY: 'top',
                color: 'text-white bg-secondary border-secondary-dark border rounded-lg',
                fontColor: 'white',
                fontTone: 0
            }).show()
        } else {
            SaveQuery(strMessage)
        }
    }

    const SaveQuery = (strMessage) => {
        const sendqueryarray = queryListJson.filter(i => i.checked == true)
        setIsSending(true)
        usePost('/commonapi/userquery',
            [{
                key: "options",
                value: strMessage
            }, {
                key: "message",
                value: ""
            }]).then(res => {
                setIsSending(false)
                if (res.Data.Table[0].ID > 0) {
                    setIsSucess(true)
                    setTimeout(
                        function () {
                            setIsSucess(false)
                        }
                            .bind(this),
                        3000
                    );
                    setQueryListJson([...queryList])
                    SendEmail(res.Data.Table[0].ID)
                    cookie.setItem("queryFormSubmmited", 1)
                    setQueryFormSubmmited(true)
                    setTempqueryarray([...sendqueryarray])
                    localStorage.setItem("tempqueryarray", JSON.stringify(tempqueryarray))
                }
            });

    }

    const SendEmail = (ID) => {
        useGet('/api/email/SendsubmitqueryEmail?ID=' + ID)
            .then(res => {
                toast().success('', 'Email Send Sucessfully').with({
                    shape: 'square',
                    duration: 2000,
                    speed: 200,
                    positionX: 'end',
                    positionY: 'top',
                    color: 'text-white bg-primary border-primary-dark border rounded-lg',
                    fontColor: 'white',
                    fontTone: 0
                }).show()

                const timer = setTimeout(() => setQueryFormSubmmited(false), 5000)  //this will added later 
                if (cookie.getItem("queryFormSubmmited") == undefined) {
                    setQueryFormSubmmited(false)
                } else {
                    setQueryFormSubmmited(true)
                }
            });
    }

    const onCustomDashboardClick = () => {
        setMemberModalVisible(true)
    }
    const onAddMember = () => {
        setMemberModalVisible(false)
        setInviteModalVisible(true)
    }
    const onInviteModalCloseTrigger = () => {
        setMemberModalVisible(true)
        setInviteModalVisible(false)
    }

    // const currentURL = window.location.href.split("/")
    // const assesid = currentURL[currentURL.length-1]
    // console.log("12312");
    // console.log(currentURL);
    // console.log(assesid);
    // console.log(cookie.getItem("needsassesmentid"));


    useEffect(() => {
        if (cookie.getItem('authorizationKey') == null && cookie.getItem('email') == null) {
            history.push("/")
        }
        localStorage.setItem("tempqueryarray", JSON.stringify(tempqueryarray))
    }, [tempqueryarray]);

    // const timer = setTimeout(() => setQueryFormSubmmited(false), 5000)  //this will added later 
    // useEffect(() => {
    //     if (cookie.getItem("queryFormSubmmited") == undefined) {
    //         setQueryFormSubmmited(false)
    //     } else {
    //         setQueryFormSubmmited(true)
    //     }
    //     clearTimeout(timer)      //this will added later 
    // }, []);



    return (
        <>
            <ProgressBar />
            <div className="relative flex w99vw ">

                {props.hideAccountDropdown ? "" : <div className="absolute right-0 top-0 mt-4 mr-8">
                    <AccountDropdown />
                </div>}

                <div className="w-20 flex-shrink-0 bg-vp-lightgray min-h-screen flex flex-col justify-between relative">
                    <div className="sticky top-0 text-vp-gray flex flex-col justify-between h-screen">
                        <div>
                            <Link to="/" className="flex pt-6 mb-8 mx-1.5 flex-col justify-center items-center">
                                <img src={ViewproIcon} alt="Viewpro Logo" />
                            </Link>
                            <NavLink
                                className="flex mb-2 mx-1.5  flex-col justify-center items-center rounded-md text-xxs uppercase px-1 h-15"
                                isActive={(match, location) => location.pathname.split("/")[1] === "dashboard"}
                                activeClassName=" text-primary bg-opacity-20" to={"/dashboard/" + cookie.getItem('needsassesmentid')}>
                                <div className="w-6 h-6 border-8 border-current rounded-full"></div>
                                <div className="mt-1">Dashboard</div>
                            </NavLink>
                            <NavLink
                                className="flex mb-2 mx-1.5 flex-col justify-center items-center rounded-md text-xxs uppercase px-1 h-15"
                                isActive={(match, location) => location.pathname.split("/")[1] === "about"}
                                activeClassName="text-primary  bg-opacity-20" to="/about/">

                                <Icon.AlertCircle className="text-current" />
                                <div className="mt-1">About</div>
                            </NavLink>
                            <NavLink
                                className="flex mb-2 mx-1.5 flex-col justify-center items-center rounded-md text-xxs uppercase px-1 h-15"
                                isActive={(match, location) => location.pathname.split("/")[1] === "connect"}
                                activeClassName="text-primary  bg-opacity-20" to="/connect/contact-us/">
                                <Icon.Mail className="text-current" />
                                <div className="mt-1">Connect</div>
                            </NavLink>
                        </div>

                        <div className="mt-auto pb-8 text-black">
                            <button
                                onClick={() => ShareWithTeam()}
                                className="flex mb-2 mx-1.5 flex-col justify-center items-center rounded-md text-xxs uppercase px-1 h-15 hover:text-primary hover:bg-vp-darkgray hover:bg-opacity-20 hidden">
                                <Icon.Users className="text-current" />
                                <div className="mt-1">Share with Team</div>
                            </button>
                            <NavLink
                                className="flex mx-1.5 flex-col justify-center items-center rounded-md text-xxs uppercase px-1 h-15"
                                isActive={(match, location) => location.pathname.split("/")[1] === "my-account"}
                                activeClassName="text-primary bg-vp-darkgray bg-opacity-20" to="/my-account/">
                                <Icon.User className="text-current" />
                                <div className="mt-1">Profile</div>
                            </NavLink>
                        </div>


                    </div>

                </div>

                <div className="w-full py-8 px-8  mx-auto dashboard-center">
                    {props.children}
                </div>

                {props.hideSidebar ? "" :
                    <div className="relative  w-55 min-w-55 2xl:w-80 3xl:w-83 4xl:w-106 4xl:flex-shrink-0 4xl:px-12 px-3.5 pb-9 border-l-2 border-vp-lightbrown">
                        <div className="right-checkbox-group sticky top-0">
                            <h2 className="pt-8 text-secondary font-bold text-xle 3xl:pt-16">What’s next?</h2>

                            {!queryFormSubmmited &&
                                <>
                                    <Transition
                                        show={true}
                                    >
                                        <div role="group">
                                            <p className="mt-2 mb-4">After selecting products, choose how to engage with us.</p>
                                            {queryListJson && queryListJson.length > 0 && queryListJson.map((item, index, array) => {
                                                return <Checkbox label={item.label} value={item.value} name={item.name} checked={item.checked} onClick={(e) => onCheckBoxClick(item, index, array)} />
                                            })}

                                            {!isSending && (
                                                <button className="bg-secondary hover:bg-secondary-dark border-secondary text-white  font-semibold  text-base py-1.5  rounded-full inline-flex border-2  active:border-3 disabled:opacity-50 whitespace-nowrap w-full items-center mt-10 justify-center" onClick={() => SubmitQuery()} >
                                                    {/* Hide SVG by default and show only when form is getting submitted
                                            {isSending && <svg className="2xl:block animate-spin -ml-1 mr-1 h-5 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>} */}
                                                    Submit your Query
                                                </button>
                                            )}
                                            {isSending && (

                                                <div className=" border-secondary  text-base py-1.5  rounded-full inline-flex border-2  active:border-3 disabled:opacity-50 whitespace-nowrap w-full items-center mt-10 justify-center" >
                                                    <div className="snippet py-1.5 px-8" data-title=".dot-pulseqry">
                                                        <div className="stage">
                                                            <div className="dot-pulseqry"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            {/* <button className="bg-secondary hover:bg-secondary-dark border-secondary text-white  font-semibold  text-base py-1.5 3xl:py-4 4xl:py-5 rounded-full inline-flex border-2  active:border-3 disabled:opacity-50 whitespace-nowrap w-full items-center mt-16 justify-center" onClick={() => SubmitQuery()} >
                                        Hide SVG by default and show only when form is getting submitted
                                        {isSending && <svg className="2xl:block animate-spin -ml-1 mr-1 h-5 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>}
                                        Submit your Query
                                        </button> */}
                                        </div>
                                    </Transition>
                                </>
                            }

                            {/* Show below div if form submitted successfully */}

                            {queryFormSubmmited &&
                                <Transition
                                    show={true}
                                    enter="transform transition-translate duration-200"
                                    enterFrom="transform translate-x-full"
                                    enterTo="transform translate-x-0"
                                    leave="transform transition-translate duration-200"
                                    leaveFrom="transform translate-x-0"
                                    leaveTo="transform translate-x-full"
                                >

                                    <div className="mt-2 mb-4" >
                                        <p className="text-sm">You have successfully sumbitted query with us. </p>
                                        <ol className="text-sm list-decimal px-4 mt-2 mb-52">
                                            <li className="text-secondary font-bold">Wait for the contact from our side.</li>
                                            <li>When we will contact you, your journey will be complete.</li>
                                            <li>You can always repeat the steps to make another journey.</li>
                                        </ol>

                                        <button className="bg-transparent hover:bg-secondary-light border-secondary text-secondary justify-center font-semibold  text-sme py-1.5 rounded-full inline-block border-2  active:border-3 whitespace-nowrap w-full mt-2">Journey completed</button>
                                    </div>
                                </Transition>
                            }

                            <div>
                                <div className='mb-4'>
                                    <h3 className="pt-9 pl-1 text-primary font-bold text-lg 3xl:pt-16">Your Submitted Query :</h3>
                                </div>
                                <div>{tempqueryarray.length == 0 ?
                                    <p>You haven't submitted any Query yet !</p> :
                                    tempqueryarray && tempqueryarray.length > 0 && tempqueryarray.map((item) => {
                                        return <SentQueryBox label={item.label} value={item.value} name={item.name} />
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>}
            </div>
            <Alert isVisible={false} type="primary" heading="Your account has been created">Please check your email with confirmation</Alert>
            <SuccessModal />
            <CreatePassswordModal isOpen={passwordModalVisible} onCustomDashboardClick={onCustomDashboardClick} closeTrigger={() => setPasswordModalVisible(false)} />
            <MembersModal isVisible={memberModalVisible} onAddMemberClick={() => onAddMember()} onCloseTrigger={() => setMemberModalVisible(false)} />
            <InviteModal isVisible={inviteModalVisible} onCloseTrigger={() => onInviteModalCloseTrigger()} />
        </>
    )
}

export default DashboardLayout
